import * as React from "react";
import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import Logout from "@mui/icons-material/Logout";
import IconButton from "@mui/material/IconButton";
import { Stack, Typography } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import ListItemIcon from "@mui/material/ListItemIcon";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { Loader } from "../common/loader";
import DialogBox from "../common/DialogBox";
import { ROLES } from "../helpers/constants";
import AlertDialog from "../common/AlertDialog";
import { spouseAction } from "../../redux/slices/spouse/spouseSlice";
import ProfileIcon from "../../assets/dashboard/Dummy_Profile_photo.png";
import { userSigInAction } from "../../redux/slices/user/userSignInSlice";
import { userProfileAction } from "../../redux/slices/user/userProfileSlice";
import { propertiesAction } from "../../redux/slices/properties/propertiesSlice";
import {
  capitalizeFirstCharInWord,
  clearLocalStoarge,
  decryptPayload,
  getObjLength,
  reactPixelEventOnlyForCustomer,
  redirectToLogin,
  stringAvatar,
} from "../helpers/utils";
import useClearLocalStorage from "../hooks/useClearLocalStorage";
import useServiceProviderPortalAccess from "../hooks/useServiceProviderPortalAccess";
import { clientShouldWaitForAgent, useCarOwnerAgentWait } from "../userProfile/Dashboard/useCarOwnerAgentWait";

export default function AccountMenu({
  hideLogout = false,
  hideMobileBar = false,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clearLocalStorageValues } = useClearLocalStorage();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isSpouseChangeModalOpen, setIsSpouseChangeModalOpen] =
    React.useState(false);

  // store data
  const userProfileDetails = useSelector(
    (state) => state.userProfile.userProfileDetails
  );
  const {
    loggedInEmail,
    loginAsSpouse: isSecondaryUser,
    switchAccountLoader,
    switchAccountDetails,
    switchedToParentUser,
  } = useSelector((state) => state?.userProfile);
  const { spouseListLoader, selectSpouseList } = useSelector(
    (state) => state?.spouse
  );
  const { canUseServiceProviderPortal, goToServiceProviderPortal } =
    useServiceProviderPortalAccess();
  const agentWait = useCarOwnerAgentWait();
  const ownerWaitsOnAgent = clientShouldWaitForAgent(agentWait);
  const brokerCompany = ownerWaitsOnAgent
    ? ""
    : userProfileDetails?.data?.default_professional_id?.company_name || "";

  // handle sign out button
  const handleSignOut = () => {
    dispatch(
      userProfileAction.logoutUser({ url: "logout", data: {}, token: true })
    );
    dispatch(userSigInAction.successLogout());
    reactPixelEventOnlyForCustomer("Signout", { email: loggedInEmail });

    dispatch(userSigInAction.successLogout());
    // localStorage.removeItem("authToken");
    // localStorage.removeItem("authorised");
    let isIos = false;
    if (JSON.parse(localStorage.getItem("isIos"))) {
      isIos = JSON.parse(localStorage.getItem("isIos")); // for both iOS and Android
    }
    // clearLocalStoarge("check_county");
    clearLocalStorageValues("check_county");
    localStorage.setItem("ivokeNativeMethod", isIos);

    redirectToLogin(navigate);
  };

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // handle open spouse change modal
  const handleOpenSpouseChangeModal = () => {
    console.log("console.log");
    setIsSpouseChangeModalOpen(true);
  };

  // handle close spouse change modal
  const handleCloseSpouseChangeModal = () => {
    setIsSpouseChangeModalOpen(false);
  };

  // actions after clicking on any spouse
  const handleLoginToSpouse = (customer) => {
    if (customer?.id) {
      // switch to parent account and then switch isSecondaryUser to true for disabling the action
      dispatch(
        userProfileAction.switchAccount({
          parent_id: customer?.id,
        })
      );
      dispatch(propertiesAction.resetProperties());
      handleCloseSpouseChangeModal();
    }
  };

  // handle back to original user
  const handleLogoutFromSpouse = () => {
    // call an API for changing the token and back to sub user
    // navigate("/user-profile");
    dispatch(propertiesAction.resetProperties());
    dispatch(userProfileAction.logoutFromSpouse());
  };

  // useEffect to fetch spouse list when spouse modal open
  useEffect(() => {
    if (isSpouseChangeModalOpen) {
      // Call API for switching to customer
      dispatch(
        spouseAction.fetchSpouseListData({
          url: `sub-user/parent-list`,
          data: {},
          token: true,
          parentList: true,
        })
      );
    }
  }, [dispatch, isSpouseChangeModalOpen]);

  return (
    <>
      {/* desktop */}
      <div
        className="px-3 account-dropdown d-none d-md-block"
        style={{
          borderLeft: "1px solid #E8ECF0",
          borderRight: "1px solid #E8ECF0",
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
        >
          <IconButton
            onClick={hideLogout ? undefined : handleClick}
            size="small"
            aria-controls={!hideLogout && open ? "account-menu" : undefined}
            aria-haspopup={hideLogout ? undefined : "true"}
            aria-expanded={!hideLogout && open ? "true" : undefined}
            disableFocusRipple
            disableRipple
            sx={hideLogout ? { cursor: "default" } : undefined}
          >
            <Avatar
              sx={{ width: 40, height: 40, mr: 1 }}
              src={
                userProfileDetails?.data?.profile_img
                  ? userProfileDetails?.data?.profile_img
                  : ProfileIcon
              }
            ></Avatar>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <Typography
                variant="h6"
                className="userName"
                sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
              >
                <span>
                  {userProfileDetails?.data?.first_name}{" "}
                  {userProfileDetails?.data?.last_name}
                </span>
                {!hideLogout ? (
                  <ArrowDropDownIcon
                    sx={{ fontSize: "20px", color: "#15BE53", flexShrink: 0 }}
                  />
                ) : null}
              </Typography>
              {isSecondaryUser ? (
                <Typography variant="caption" className="companyName">
                  Switched User
                </Typography>
              ) : null}
              {ownerWaitsOnAgent ? (
                <Typography variant="caption" className="companyName">
                  {userProfileDetails?.data?.email}
                </Typography>
              ) : brokerCompany ? (
                <Typography variant="caption" className="companyName">
                  {brokerCompany}
                </Typography>
              ) : null}
            </Box>
          </IconButton>
        </Box>
        {!hideLogout ? (
          <Menu
            anchorEl={anchorEl}
            className="d-none d-md-block"
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 24,
                  height: 24,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {canUseServiceProviderPortal ? (
              <MenuItem
                className="profile-items"
                onClick={goToServiceProviderPortal}
              >
                <ListItemIcon>
                  <BusinessCenterOutlinedIcon fontSize="medium" />
                </ListItemIcon>
                Service Provider portal
              </MenuItem>
            ) : null}
            <MenuItem className="profile-items" onClick={handleSignOut}>
              <ListItemIcon>
                <Logout fontSize="medium" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        ) : null}
      </div>

      {/* mobile */}
      {!hideMobileBar ? (
      <div
        className="px-3 account-dropdown mobile d-block d-md-none"
        style={{ borderBottom: "1px solid #E8ECF0" }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent:
              brokerCompany || isSecondaryUser
                ? "space-between"
                : "flex-end !important",
          }}
        >
          {ownerWaitsOnAgent ? (
            <Typography variant="caption" className="companyName">
              {userProfileDetails?.data?.email}
            </Typography>
          ) : brokerCompany ? (
            <Typography variant="caption" className="companyName">
              {brokerCompany}
            </Typography>
          ) : null}
          {isSecondaryUser ? (
            <Typography variant="caption" className="companyName">
              Switched User
            </Typography>
          ) : null}
          <Typography variant="h6">
            <IconButton
              onClick={hideLogout ? undefined : handleClick}
              size="small"
              className="userName"
              aria-controls={!hideLogout && open ? "account-menu" : undefined}
              aria-haspopup={hideLogout ? undefined : "true"}
              aria-expanded={!hideLogout && open ? "true" : undefined}
              disableFocusRipple
              disableRipple
              sx={hideLogout ? { cursor: "default" } : undefined}
            >
              {" "}
              {userProfileDetails?.data?.first_name}{" "}
              {userProfileDetails?.data?.last_name}
              {!hideLogout ? (
                <ArrowDropDownIcon
                  sx={{ ms: 1, fontSize: "20px", color: "#15BE53" }}
                />
              ) : null}
            </IconButton>
          </Typography>
        </Stack>
        {!hideLogout ? (
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            className="d-block d-md-none"
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 24,
                  height: 24,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {canUseServiceProviderPortal ? (
              <MenuItem
                className="profile-items"
                onClick={goToServiceProviderPortal}
              >
                <ListItemIcon>
                  <BusinessCenterOutlinedIcon fontSize="medium" />
                </ListItemIcon>
                Service Provider portal
              </MenuItem>
            ) : null}
            <MenuItem className="profile-items" onClick={handleSignOut}>
              <ListItemIcon>
                <Logout fontSize="medium" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        ) : null}
      </div>
      ) : null}

      <DialogBox
        width={"xs"}
        openPopup={isSpouseChangeModalOpen}
        setOpenPopup={setIsSpouseChangeModalOpen}
        onClose={handleCloseSpouseChangeModal}
        dividers={false}
        title={
          <>
            <Box className="d-flex justify-content-left align-items-center py-2 px-3">
              Customer List
            </Box>
          </>
        }
        content={
          <>
            {/* display list of customer whom, sub-user is exist and want to switch in that customer */}
            {selectSpouseList?.data?.length > 0 ? (
              <Box className="" sx={{ maxHeight: "400px", overflowY: "auto" }}>
                {selectSpouseList?.data?.map((customer, index) => {
                  return (
                    customer?.id !== parseInt(localStorage.getItem("uID")) && (
                      <>
                        <Stack
                          key={customer?.id}
                          spacing={2}
                          direction={{ xs: "column", sm: "row" }}
                          alignItems="center"
                          className="bg-white my-2 px-3 py-2 rounded cursor-pointer"
                          onClick={() => {
                            handleLoginToSpouse(customer);
                          }}
                        >
                          <Avatar
                            {...stringAvatar(
                              capitalizeFirstCharInWord(
                                `${customer?.first_name} ${customer?.last_name}`
                              )
                            )}
                          />
                          <Stack
                            direction="column"
                            alignItems={{ sm: "flex-start", xs: "center" }}
                          >
                            <Typography variant="subtitle1" className="fw-600">
                              {capitalizeFirstCharInWord(
                                `${customer?.first_name} ${customer?.last_name}`
                              )}
                            </Typography>
                            <Typography>{customer?.email}</Typography>
                          </Stack>
                        </Stack>
                      </>
                    )
                  );
                })}
              </Box>
            ) : (
              <Typography className="text-black fs-5 p-4 text-center">
                No Data Found
              </Typography>
            )}

            <Loader open={spouseListLoader || switchAccountLoader} />
          </>
        }
        // footer={modalFooter()}
      />

      {getObjLength(switchAccountDetails) &&
        (switchAccountDetails?.success ? (
          <AlertDialog
            type="Success"
            openPopup={true}
            onClose={true}
            onCloseFun={() => {
              dispatch(userProfileAction.clearSwitchSpouseDetails());
              handleCloseSpouseChangeModal();
            }}
            mesage={switchAccountDetails?.message}
            footer={false}
          />
        ) : (
          <AlertDialog
            type="Error"
            openPopup={true}
            onClose={true}
            onCloseFun={() => {
              dispatch(userProfileAction.clearSwitchSpouseDetails());
            }}
            mesage={switchAccountDetails?.data?.message}
            footer={false}
          />
        ))}
    </>
  );
}
